import styled from 'styled-components'

import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import { Note as NoteBase } from '@icontainers/design-system/dist/molecules/Note'
import { Accordion as AccordionBase } from '@icontainers/design-system/dist/organisms/Accordion'

export const Container = styled.div`
    max-width: 1170px;
    margin: 0 auto 10px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin: 0 auto 100px;
    }
    padding-left: 10px;
    padding-right: 10px;
    ${(props) => props.theme.typo.bodyM};
    color: ${(props) => props.theme.color.g400};
`

export const Title = styled.h2`
    ${(props) => props.theme.typo.displayL};
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 10px;

    @media ${(props) => props.theme.query.mobile} {
        ${(props) => props.theme.typo.displayS};
    }
`

export const Button = styled(ButtonBase)`
    @media ${(props) => props.theme.query.min.tablet} {
        flex: 0;
    }
    @media ${(props) => props.theme.query.mobile} {
        margin-top: 10px;
    }

    button {
        height: 56px;
    }
`

export const Wrapper = styled.div`
    background: ${(props) => props.theme.color.p600};
    padding: 15px;
    @media ${(props) => props.theme.query.min.tablet} {
        padding: 50px;
    }
    color: ${(props) => props.theme.color.white};
    border-radius: 10px;
    margin: 15px 0px;
    @media ${(props) => props.theme.query.min.tablet} {
        margin: 100px 0;
    }

    input {
        width: 100%;
    }
`

export const InputWrapper = styled.div`
    @media ${(props) => props.theme.query.min.tablet} {
        display: flex;
        gap: 10px;
        max-width: 820px;
    }
`

export const SmallTitle = styled.h3`
    ${(props) => props.theme.typo.displayS};
    ${(props) => props.theme.fontWeight.medium};
    text-transform: uppercase;
    color: ${(props) => props.theme.color.p500};
`

export const Highlight = styled.b`
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.black};
    display: block;
`

export const EvenRow = styled.div`
    background-color: ${(props) => props.theme.color.g100};
    border-radius: 8px;
`

export const TimeColumn = styled.div`
    width: 90px;
    text-align: right;
    margin: 16px 24px 16px;

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;
        display: flex;
        margin: 8px 16px;
        justify-content: space-between;
        text-align: left;
    }
`

export const ContentColumn = styled.div`
    flex: 1;
    margin: 16px;

    @media ${(props) => props.theme.query.mobile} {
        margin-top: 0px;
    }
`

export const Note = styled(NoteBase)`
    margin: 10px 0;
`

export const InfoRow = styled.div`
    padding: 16px 0;
    border-bottom: 1px dashed ${(props) => props.theme.color.g300};
    > div {
        flex: 1;
    }
`

export const InfoColumn = styled.div`
    text-align: right;
`

export const ShipmentInformationColumn = styled.div`
    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 320px;
    }
    width: 100%;
`

export const ShipmentActivityColumn = styled.div`
    margin-bottom: 10px;
    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 0;
    }
    flex: 1;
`

export const Accordion = styled(AccordionBase)`
    background-color: ${(props) => props.theme.color.white};

    .description-accordion-title {
        ${(props) => props.theme.fontWeight.medium};
    }
`
